import React from 'react'
import AddAdditionalIdeas from '../AddAdditionalIdeas.js'
import SectionThree from './SectionThree.js'
import { useExercise } from '../ExerciseProvider.js'
import Questions from './Questions.js'

const DesignThinkingExercise = ({ section, questions, conclusion }) => {
  const { trackContent } = useExercise()
  return (
    <>
      {section !== 3 && <Questions questions={questions} section={section} />}
      {section === 2 && <AddAdditionalIdeas />}
      {section === 3 && <SectionThree data={trackContent} />}
      <div className="mt-6 font-roboto text-lg">{conclusion}</div>
    </>
  )
}

export default DesignThinkingExercise
